import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

var Section = function Section(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames('cloud-ui-page-section', className)
  }, rest), children);
};

Section.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
export default Section;